import { render, staticRenderFns } from "./SidebarFilterCustomerCoupon.vue?vue&type=template&id=6bd15c52&scoped=true"
import script from "./SidebarFilterCustomerCoupon.vue?vue&type=script&lang=js"
export * from "./SidebarFilterCustomerCoupon.vue?vue&type=script&lang=js"
import style0 from "./SidebarFilterCustomerCoupon.vue?vue&type=style&index=0&id=6bd15c52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd15c52",
  null
  
)

export default component.exports